import axios from 'axios'
import store from '../store'
import { URL } from '../const'

import {
  RESET_DATA,
  FETCHING_DATA,
  FETCH_DATA_SUCCESS,
  FETCH_DATA_FAIL,
  SET_FILTER_FIELD,
  SET_FILTER_VALUE,
  RESET_FILTER
} from './types'

export const fetchData = (route) => async dispatch => {
  dispatch({ type: FETCHING_DATA })

  const headers = {
    'Authorization': `Token ${store.getState().user.token}`
  }
  const url = `${URL}${route}`

  // console.log('params: ', params)
  // console.log('auth: ', auth)

  try {
    const res = await axios.get(
      url,
      { headers }
    )
    // console.log('res: ', res)
    dispatch({
      type: FETCH_DATA_SUCCESS,
      payload: res.data.items
    })
  } catch (error) {
    console.log('error: ', error)
    dispatch({ type: FETCH_DATA_FAIL, payload: error })
  }
}
export const setFieldFilter = (field) => {
  return {
    type: SET_FILTER_FIELD,
    payload: field
  }
}

export const setValueFilter = (value) => {
  return {
    type: SET_FILTER_VALUE,
    payload: value
  }
}

export const resetFilter = () => {
  return {
    type: RESET_FILTER
  }
}

export const resetList = () => {
  // console.log('reset data')
  return {
    type: RESET_DATA
  }
}



// WEBPACK FOOTER //
// ./src/actions/listActions.js